import React, { useState, useEffect } from 'react';
import { useCart } from 'react-use-cart';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../../Contexts/NotificationContext';

import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import particlesConfig from '../../../Shared/pr-s-black';

import wixClassicLogo from '../../../Assets/Images/Wix_logos/Wix_choices/Wixclassic_logo.png';
import wixEditorXLogo from '../../../Assets/Images/Wix_logos/Wix_choices/Wixeditorx_logo.png';
import wixStudioLogo from '../../../Assets/Images/Wix_logos/Wix_choices/Wixstudio_logo.png';
import wixBlogLogo from '../../../Assets/Images/Wix_logos/Wix_addons/Wixblog_addon.png';
import wixBookingLogo from '../../../Assets/Images/Wix_logos/Wix_addons/Wixbooking_addon.png';
import wixEventsLogo from '../../../Assets/Images/Wix_logos/Wix_addons/Wixevents_addon.png';
import wixFaqLogo from '../../../Assets/Images/Wix_logos/Wix_addons/Wixfaq_addon.png';
import wixForumLogo from '../../../Assets/Images/Wix_logos/Wix_addons/Wixforum_addon.png';
import wixMembersLogo from '../../../Assets/Images/Wix_logos/Wix_addons/Wixmembersarea_addon.png';
import wixMultilLogo from '../../../Assets/Images/Wix_logos/Wix_addons/Wixmultil_addon.png';
import wixOnlineprogLogo from '../../../Assets/Images/Wix_logos/Wix_addons/Wixonlineprog_addon.png';
import wixStoreLogo from '../../../Assets/Images/Wix_logos/Wix_addons/Wixstore_addon.png';

const particlesInit = async (engine) => {
  // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
  await loadSlim(engine);
};

const particlesLoaded = async (container) => {
  // Particles loaded callback
};

const plans_wix_classic = {
  introductory: {
    name: "Introductory Plan",
    price: "$999.99",
    features: ["Performance Tracking", "Analytic Dashboard", "Backlink Optimization", "Domain Pluggin", "Level 3 Security", "Keywords Optimization"],
  },
  intermediate: {
    name: "Intermediate Plan",
    price: "$1,499.99",
    features: ["Performance Tracking", "Analytic Dashboard", "Backlink Optimization", "Domain Pluggin", "Level 3 Security", "Keywords Optimization"],
  },
  advanced: {
    name: "Advanced Plan",
    price: "$1,999.99",
    features: ["Performance Tracking", "Analytic Dashboard", "Backlink Optimization", "Domain Pluggin", "Level 3 Security", "Keywords Optimization"],
  },
};

const plans_wix_editorx = {
  introductory: {
    name: "Introductory Plan",
    price: "$1,499.99",
    features: ["Performance Tracking", "Analytic Dashboard", "Backlink Optimization", "Domain Pluggin", "Level 3 Security", "Keywords Optimization"],
  },
  intermediate: {
    name: "Intermediate Plan",
    price: "$2,499.99",
    features: ["Performance Tracking", "Analytic Dashboard", "Backlink Optimization", "Domain Pluggin", "Level 3 Security", "Keywords Optimization"],
  },
  advanced: {
    name: "Advanced Plan",
    price: "$3,499.99",
    features: ["Performance Tracking", "Analytic Dashboard", "Backlink Optimization", "Domain Pluggin", "Level 3 Security", "Keywords Optimization"],
  },
};

const plans_wix_studio = {
  introductory: {
    name: "Introductory Plan",
    price: "$1,499.99",
    features: ["Performance Tracking", "Analytic Dashboard", "Backlink Optimization", "Domain Pluggin", "Level 3 Security", "Keywords Optimization"],
  },
  intermediate: {
    name: "Intermediate Plan",
    price: "$2,499.99",
    features: ["Performance Tracking", "Analytic Dashboard", "Backlink Optimization", "Domain Pluggin", "Level 3 Security", "Keywords Optimization"],
  },
  advanced: {
    name: "Advanced Plan",
    price: "$3,999.99",
    features: ["Performance Tracking", "Analytic Dashboard", "Backlink Optimization", "Domain Pluggin", "Level 3 Security", "Keywords Optimization"],
  },
};

const addons_wix = {
  store: {
    name: "Wix Store",
    price: "$999.99",
    features: ["Monthly Call Review", "Analytic Dashboard"],
    color: "#1A3689",
  },
  Blog: {
    name: "Wix Blog",
    price: "$349.99",
    features: ["Monthly Call Review", "Analytic Dashboard"],
    color: "#1A3689",
  },
  Faq: {
    name: "Wix FAQ",
    price: "$249.99",
    features: ["Monthly Call Review", "Analytic Dashboard"],
    color: "#9088E5",
  },
  Events: {
    name: "Wix Events",
    price: "$399.99",
    features: ["Monthly Call Review", "Analytic Dashboard"],
    color: "#5D1444",
  },
  Bookings: {
    name: "Wix Bookings",
    price: "$499.99",
    features: ["Monthly Call Review", "Analytic Dashboard"],
    color: "#5550EC",
  },
  Pricingplan: {
    name: "Wix Pricing Plan",
    price: "$499.99",
    features: ["Monthly Call Review", "Analytic Dashboard"],
    color: "#3673A2",
  },
  Forum: {
    name: "Wix Forum",
    price: "$499.99",
    features: ["Monthly Call Review", "Analytic Dashboard"],
    color: "#2C70F6",
  },
  Onlineprog: {
    name: "Wix Online Programs",
    price: "$499.99",
    features: ["Monthly Call Review", "Analytic Dashboard"],
    color: "#5550EC",
  },
  Members: {
    name: "Wix Members Area",
    price: "$499.99",
    features: ["Monthly Call Review", "Analytic Dashboard"],
    color: "#5354E4",
  },
};

export default function Wix({ createOrderFunction }) {
  const { addItem } = useCart();
  const navigate = useNavigate();
  const { showSuccess, showError } = useNotification();
  const [selectedEditor, setSelectedEditor] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showAddons, setShowAddons] = useState(false);
  const [selectedAddons, setSelectedAddons] = useState({});
  const [selectedClient, setSelectedClient] = useState(localStorage.getItem('selectedClient'));

  useEffect(() => {
    const handleStorageChange = () => {
      setSelectedClient(localStorage.getItem('selectedClient'));
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const handleEditorSelect = (editor) => {
    setSelectedEditor(editor);
    setSelectedPlan(null);
    setShowAddons(false);
    // Scroll to the plans section after a short delay to ensure it's rendered
    setTimeout(() => {
      const plansSection = document.getElementById('wix-plans-section');
      if (plansSection) {
        plansSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
    setShowAddons(true);
  
    // Using setTimeout to allow state update and rendering before scrolling
    setTimeout(() => {
      const addonsSection = document.getElementById('wix-addons-section');
      if (addonsSection) {
        addonsSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  // Retrieve the correct plans based on the selected editor
  const getPlans = () => {
    if (selectedEditor === 'classic') return plans_wix_classic;
    if (selectedEditor === 'editorx') return plans_wix_editorx;
    if (selectedEditor === 'studio') return plans_wix_studio;
    return {};
  };

  // Function to get the correct image for each addon
  const getAddonImage = (addonKey) => {
    const addonImages = {
      store: wixStoreLogo,
      Blog: wixBlogLogo,
      Faq: wixFaqLogo,
      Events: wixEventsLogo,
      Bookings: wixBookingLogo,
      Pricingplan: wixMultilLogo,
      Forum: wixForumLogo,
      Onlineprog: wixOnlineprogLogo,
      Members: wixMembersLogo,
    };
    return addonImages[addonKey];
  };

  const toggleAddonSelection = (addonKey, addonPrice) => {
    setSelectedAddons(prevSelectedAddons => {
      const newAddons = { ...prevSelectedAddons };
      if (newAddons[addonKey]) {
        delete newAddons[addonKey];
      } else {
        newAddons[addonKey] = parseFloat(addonPrice.replace(/\$/g, '')); // Remove the dollar sign and parse to float
      }
      return newAddons;
    });
  };


  const calculateSubtotal = () => {
    const planPrice = selectedPlan ? parseFloat(getPlans()[selectedPlan].price.replace(/[$,]/g, '')) : 0;
    const addonsPrice = Object.values(selectedAddons).reduce((sum, price) => sum + price, 0);
    return (planPrice + addonsPrice).toFixed(2); // Fixed to 2 decimal places
  };

  // Build a cart item from the current Wix selection. The id contains
  // "website" so the checkout maps it to the correct catalogue item.
  const buildCartItem = () => {
    if (!selectedPlan) return null;
    const plan = getPlans()[selectedPlan];
    const planPrice = parseFloat((plan?.price || '0').replace(/[$,]/g, '')) || 0;
    const addonsPrice = Object.values(selectedAddons).reduce((sum, price) => sum + price, 0);
    const total = Number((planPrice + addonsPrice).toFixed(2));
    const addonNames = Object.keys(selectedAddons);
    return {
      id: `website-wix-${selectedPlan}`,
      name: `Wix Website — ${selectedPlan}`,
      price: total,
      quantity: 1,
      platform: 'Wix',
      description: addonNames.length ? `Add-ons: ${addonNames.join(', ')}` : undefined,
    };
  };

  const handleAddToCart = () => {
    const item = buildCartItem();
    if (!item) {
      showError('Please choose a plan first.');
      return;
    }
    addItem(item);
    showSuccess('Added to cart.');
  };

  const handleBuyNow = () => {
    const item = buildCartItem();
    if (!item) {
      showError('Please choose a plan first.');
      return;
    }
    addItem(item);
    navigate('/checkout');
  };

  return (
    <div id="wix-page" key="wix-page-unique">
      {/* Hero Section */}
      <section className="wix-hero">
        <div className="particles circle-bg">
          <div className="container">
            <div className="title-box">
              <h6>WEBSITE DEVELOPMENT</h6>
              <h1>
                <span className="color-font">Wix</span> Website Solutions
              </h1>
              <p className="hero-subtitle">Choose from various editors tailored to different needs. Whether you're a beginner or a pro, there's something for everyone.</p>
            </div>
          </div>

          <Particles
            id="particles-js"
            init={particlesInit}
            options={particlesConfig}
          />

          <div className="gradient-circle"></div>
          <div className="gradient-circle two"></div>
        </div>
      </section>

      {/* Editor Selection Section */}
      <section className="editor-selection-section" key="editor-selection">
        <div className="container">
          <h2><span className="color-font">Choose Your</span> Wix Editor</h2>
          <div className="editor-grid">
            <div className={`editor-card wix-classic ${selectedEditor === 'classic' ? 'selected' : ''}`} onClick={() => handleEditorSelect('classic')}>
              <div className="editor-image">
                <img src={wixClassicLogo} alt="Classic Wix" />
              </div>
              <h3>Wix Classic</h3>
              <p>Perfect for beginners and small businesses</p>
            </div>
            <div className={`editor-card wix-editorx ${selectedEditor === 'editorx' ? 'selected' : ''}`} onClick={() => handleEditorSelect('editorx')}>
              <div className="editor-image">
                <img src={wixEditorXLogo} alt="Editor X" />
              </div>
              <h3>Editor X</h3>
              <p>Advanced design capabilities for professionals</p>
            </div>
            <div className={`editor-card wix-studio ${selectedEditor === 'studio' ? 'selected' : ''}`} onClick={() => handleEditorSelect('studio')}>
              <div className="editor-image">
                <img src={wixStudioLogo} alt="WIX Studio" />
              </div>
              <h3>Wix Studio</h3>
              <p>Enterprise-level solutions for agencies</p>
            </div>
          </div>
        </div>
      </section>

      {/* Plans Section */}
      {selectedEditor && (
        <section id="wix-plans-section" className="plans-section">
          <div className="container">
            <h2><span className="color-font">Select Your</span> Plan</h2>
            <div className="plans-grid">
              {Object.entries(getPlans()).map(([key, value]) => (
                <div key={key} 
                     className={`plan-card ${selectedPlan === key ? 'selected' : ''}`}
                     onClick={() => handlePlanSelect(key)}>
                  <h3>{value.name}</h3>
                  <div className="plan-price">{value.price}</div>
                  <ul className="plan-features">
                    {value.features.map((feature, index) => <li key={index}>{feature}</li>)}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
      {/* Addons Section */}
      {showAddons && (
        <section id="wix-addons-section" className="addons-section">
          <div className="container">
            <h2><span className="color-font">Select</span> Add-ons</h2>
            <div className="addons-grid">
              {Object.entries(addons_wix).map(([key, addon]) => (
                <div key={key} 
                     className={`addon-card ${selectedAddons[key] ? 'selected' : ''}`} 
                     onClick={() => toggleAddonSelection(key, addon.price)}>
                  <div className="addon-image">
                    <img src={getAddonImage(key)} alt={addon.name} />
                  </div>
                  <div className="addon-content">
                    <h3>{addon.name}</h3>
                    <div className="addon-price">{addon.price}</div>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="order-summary">
              <h3>Order Summary</h3>
              <div className="summary-line">
                <span>Website Plan:</span>
                <span>${selectedPlan ? getPlans()[selectedPlan].price : '0.00'}</span>
              </div>
              <div className="summary-line">
                <span>Add-ons:</span>
                <span>${Object.values(selectedAddons).reduce((sum, price) => sum + price, 0).toFixed(2)}</span>
              </div>
              <div className="summary-line total">
                <span>Total:</span>
                <span>${calculateSubtotal()}</span>
              </div>
            </div>

            <div className="action-buttons">
              <button onClick={handleAddToCart} className="add-to-cart-btn">Add to Cart</button>
              <button onClick={handleBuyNow} className="buy-now-btn">Buy Now</button>
            </div>
          </div>
        </section>
      )}
    </div>
  );
   
}
